
var utils = {
  wait(time) {
    return new Promise((resovle) => {
      setTimeout(resovle, time);
    });
  },
  getErrorItem({ status_code, error }) {
    let statusCode = status_code;
    if (error && error.status) {
      statusCode = error.status;
    }
    let errorMessage = {
      404: {
        title: "大変申し訳ございませんが、\nページが見つからないようです。",
        description: '',
      },
      500: {
        title: "大変申し訳ございませんが、\nページを表示することができません。",
        description: "しばらくしてからもう一度お試しください。",
      },
      503: {
        title: 'ただいまメンテナンス中です',
        description: "時間をおいて再度アクセスしてください",
      },
    }[statusCode];

    // デフォルト対応
    if (!errorMessage) {
      errorMessage = {
        title: "問題が発生しました",
        description: "時間をおいて再度お試しください",
      };
    }

    if (error && error.customMessage) {
      errorMessage.description = error.customMessage;
    }

    //- 503 のときはエラーコードを表示しない
    if (statusCode === 503) {
      statusCode = null;
    }
    return {
      statusCode,
      errorMessage,
      title: errorMessage.title,
    };
  },
  preloadModuleProvider: (provider_id, onetime_hash) => {
    let preload = {
      'paypay': async () => {
        let { account_link_qr_code } = await app.api.child('paypay/account_link_qr_code').post({
          onetime_hash,
        });
        return { accountLinkQrCode: account_link_qr_code };
      },
      'ponta': () => { },
      'point_at_gift': () => { },
      'google_play_gift_code': () => { },
      'apple_gift_card': () => { },
      'amazon_gift_card': () => { },
    }[provider_id || ''] || (() => { });

    return preload();
  },
};

export default utils;

